export { default } from './IconButton';



// WEBPACK FOOTER //
// ./src/design-system/atoms/IconButton/index.jsx